import { arrayOf, shape, string, func } from 'prop-types';
import React from 'react';
import Link from 'components/Link';
import siteHeaderNavBlockStyles from './siteHeaderNavBlockStyles';

function SiteHeaderNavBlock({
  parent,
  sections,
  handleNavClick,
  handleNavItemClick
}) {
  return (
    <div className="SiteHeaderNavBlock">
      {parent && (
        <p className="SiteHeaderNavBlock__heading">
          <Link href={parent.href} as={parent.as && parent.as}>
            <a data-gtm-nav-category={parent.label} onClick={handleNavClick}>
              {parent.label}
            </a>
          </Link>
        </p>
      )}

      {sections.map(section => (
        <div className="SiteHeaderNavBlock__section" key={section.sectionName}>
          <p
            className="SiteHeaderNavBlock__section-name"
            dangerouslySetInnerHTML={{ __html: section.sectionName }}
          />
          <ul className="SiteHeaderNavBlock__section-links">
            {section.sectionLinks.map(({ label, href, as }) => {
              const linkProps = {
                href,
                ...(as && { as })
              };
              return (
                <li
                  className="SiteHeaderNavBlock__section-links-item"
                  key={label}
                >
                  <Link {...linkProps}>
                    <a
                      data-gtm-nav-category={parent.label}
                      data-gtm-nav-section={section.sectionName}
                      data-gtm-nav-item={label}
                      className="SiteHeaderNavBlock__section-link"
                      onClick={handleNavItemClick}
                    >
                      {label}
                    </a>
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      ))}
      <style jsx>{siteHeaderNavBlockStyles}</style>
    </div>
  );
}

SiteHeaderNavBlock.propTypes = {
  parent: shape({
    label: string.isRequired,
    href: string.isRequired,
    as: string
  }).isRequired,
  sections: arrayOf(
    shape({
      sectionName: string,
      sectionLinks: arrayOf(
        shape({
          // TBD
        })
      )
    })
  ),
  handleNavClick: func.isRequired,
  handleNavItemClick: func.isRequired
};

SiteHeaderNavBlock.defaultProps = {
  sections: []
};

export default SiteHeaderNavBlock;
